import { z } from "zod";
/**
 * Hata kodları: sabit İngilizce sabitler (AGENTS.md §3.9). İstemciler metne değil KODA göre davranır.
 * Yeni kod eklerken varsayılan HTTP durumu ve Türkçe başlığı da burada tanımlanır.
 */
export const ERROR_CODES = {
    VALIDATION_ERROR: { status: 400, title: "Gönderilen veriler geçersiz" },
    UNAUTHENTICATED: { status: 401, title: "Oturum açmanız gerekiyor" },
    INVALID_CREDENTIALS: { status: 401, title: "E-posta ya da parola hatalı" },
    MFA_INVALID_CODE: { status: 401, title: "Doğrulama kodu hatalı" },
    SESSION_REVOKED: { status: 401, title: "Oturumunuz sonlandırıldı" },
    REAUTHENTICATION_REQUIRED: {
        status: 401,
        title: "Bu işlem için kimliğinizi yeniden doğrulamanız gerekiyor",
    },
    // Mobil biyometrik step-up (Prompt 21, ADR 0021 §4): meydan okuma geçersiz / süresi dolmuş / kullanılmış, cihaz iptal
    // edilmiş ya da imza tutmuyor — ayrım YAPILMAZ (bilgi sızdırmama); istemci parola / kod yoluna düşer.
    DEVICE_STEP_UP_FAILED: { status: 401, title: "Cihaz doğrulaması başarısız; parolanızla doğrulayın" },
    FORBIDDEN: { status: 403, title: "Bu işlem için yetkiniz yok" },
    FEATURE_DISABLED: { status: 403, title: "Bu modül hesabınızda etkin değil" },
    TENANT_SUSPENDED: { status: 403, title: "Hesabınız askıya alınmış" },
    MFA_SETUP_REQUIRED: { status: 403, title: "Bu hesap için iki adımlı doğrulama zorunludur" },
    PLAN_LIMIT_REACHED: { status: 403, title: "Paketinizin sınırına ulaşıldı" },
    TENANT_READ_ONLY: { status: 403, title: "Hesabınız salt okunur durumda" },
    NOT_FOUND: { status: 404, title: "Kayıt bulunamadı" },
    CONFLICT: { status: 409, title: "İşlem mevcut bir kayıtla çakışıyor" },
    VERSION_CONFLICT: { status: 409, title: "Kayıt başka bir kullanıcı tarafından değiştirilmiş" },
    IDEMPOTENCY_KEY_REUSED: { status: 409, title: "Idempotency-Key farklı bir istekle daha önce kullanılmış" },
    IDEMPOTENCY_IN_PROGRESS: { status: 409, title: "Aynı istek şu anda işleniyor" },
    IDEMPOTENCY_KEY_REQUIRED: { status: 400, title: "Bu uç için Idempotency-Key başlığı zorunludur" },
    PERIOD_CLOSED: { status: 409, title: "Muhasebe dönemi kapalı" },
    PERIOD_NOT_FOUND: { status: 409, title: "Bu tarih için açılmış bir mali dönem yok" },
    UNBALANCED_ENTRY: { status: 422, title: "Fişin borç ve alacak toplamı eşit değil" },
    ACCOUNT_NOT_POSTABLE: { status: 422, title: "Bu hesaba kayıt atılamaz" },
    DIMENSION_REQUIRED: { status: 422, title: "Hesap için zorunlu boyut eksik" },
    ACCOUNT_IN_USE: { status: 409, title: "Hesap kullanımda olduğu için bu işlem yapılamaz" },
    INVALID_STATE_TRANSITION: { status: 409, title: "Kayıt bu işlem için uygun durumda değil" },
    DUPLICATE_TAX_ID: { status: 409, title: "Bu VKN/TCKN ile kayıtlı başka bir cari var" },
    COUNTERPARTY_BLOCKED: { status: 409, title: "Cari blokeli: işlem yapılamaz" },
    CREDIT_LIMIT_EXCEEDED: { status: 422, title: "Carinin kredi limiti aşılıyor" },
    ALLOCATION_EXCEEDS_REMAINING: { status: 422, title: "Eşleştirme tutarı açık kalemin kalanını aşıyor" },
    INSUFFICIENT_CASH_BALANCE: {
        status: 409,
        title: "Kasa bakiyesi yetersiz: şirket ayarı negatif bakiyeye izin vermiyor",
    },
    DUPLICATE_STATEMENT: { status: 409, title: "Bu ekstre dosyası daha önce içe aktarılmış" },
    DBS_LIMIT_EXCEEDED: { status: 409, title: "DBS limiti yetersiz" },
    DUPLICATE_INSTRUMENT: { status: 409, title: "Bu çek daha önce kaydedilmiş" },
    DUPLICATE_INVOICE: { status: 409, title: "Bu fatura daha önce kaydedilmiş" },
    DUPLICATE_EXPENSE: { status: 409, title: "Bu gider belgesi daha önce kaydedilmiş" },
    PAYMENT_SOURCE_LOCKED: { status: 409, title: "Bu ödeme kaynağı başka bir partide bekliyor" },
    RECEIPT_ALREADY_INVOICED: { status: 409, title: "Bu ÖKC fişi daha önce faturalanmış" },
    RETURN_EXCEEDS_ORIGINAL: { status: 409, title: "İade miktarı faturadaki kalan miktarı aşıyor" },
    EDOCUMENT_PROVIDER_ERROR: { status: 502, title: "e-Belge sağlayıcısına ulaşılamadı" },
    IMMUTABLE_RECORD: { status: 409, title: "Kesinleşmiş kayıt değiştirilemez" },
    STRAPPING_TABLE_MISSING: { status: 409, title: "Tankın geçerli bir kalibrasyon tablosu yok" },
    READING_OUT_OF_RANGE: { status: 422, title: "Okuma kalibrasyon tablosunun aralığı dışında" },
    READING_REQUIRED: { status: 409, title: "Bu adım için tank okuması gerekiyor" },
    SETTLE_TIME_NOT_ELAPSED: { status: 409, title: "Oturma süresi henüz dolmadı" },
    DUPLICATE_DELIVERY: { status: 409, title: "Bu irsaliye daha önce teslim alınmış" },
    PERIOD_NOT_CLOSED: { status: 409, title: "Dönem henüz bitmedi" },
    // Vardiya ve gün sonu (Prompt 13)
    SHIFT_ALREADY_OPEN: { status: 409, title: "Bu istasyonda zaten açık bir vardiya var" },
    PREVIOUS_SHIFT_NOT_CLOSED: { status: 409, title: "Önceki vardiya henüz kapatılmadı" },
    BUSINESS_DAY_LOCKED: { status: 409, title: "İş günü kilitli: kayıt eklenemez ya da değiştirilemez" },
    SHIFT_NOT_OPEN: { status: 409, title: "Vardiya kayıt almaya açık değil" },
    NOZZLE_ALREADY_ASSIGNED: { status: 409, title: "Bu tabanca aynı anda başka bir kişiye atanmış" },
    OPENING_TOTALIZER_REASON_REQUIRED: {
        status: 400,
        title: "Elle girilen endeks son okumadan çok sapıyor: gerekçe zorunlu",
    },
    TOTALIZER_BELOW_LAST_READING: { status: 400, title: "Endeks son okumanın altına indirilemez" },
    STAFF_NOT_IN_STATION: { status: 400, title: "Personel bu istasyona ait değil ya da pasif" },
    SHIFT_NOT_CLOSING: { status: 409, title: "Vardiyanın kapanışı henüz başlatılmadı" },
    SHIFT_CLOSINGS_INCOMPLETE: { status: 409, title: "Tüm pompacı / kasiyer hesapları kabul edilmedi" },
    SHIFT_TENDER_DERIVED: {
        status: 400,
        title: "Veresiye / filo tahsilatı elle girilemez: vardiya içi fişlerden türetilir",
    },
    SHIFT_PRICE_SEGMENT_MISSING: {
        status: 422,
        title: "Vardiya aralığında bu ürün için geçerli istasyon fiyatı yok",
    },
    DAY_END_PRECONDITIONS: { status: 409, title: "Gün sonu ön koşulları karşılanmadı" },
    DAY_SUMMARY_UNBALANCED: {
        status: 409,
        title: "Gün sonu özet fişi dengelenemedi: bir hesabın farkı karşılanmamış",
    },
    Z_REPORT_DUPLICATE: { status: 409, title: "Bu ÖKC için aynı Z numarası zaten girilmiş" },
    DAY_CORRECTION_PERIOD_CLOSED: {
        status: 422,
        title: "Düzeltme kaydının dönemi kapalı: açık bir kayıt tarihi verin",
    },
    FUEL_SALES_SUMMARY_CONFLICT: {
        status: 422,
        title: "Vardiya modülü açıkken akaryakıt gün sonu satış özeti fişi açılamaz",
    },
    // İstasyon ajanı (Prompt 14) — protokol hataları: `docs/domain/agent-protocol.md`
    AGENT_ENROLLMENT_CODE_INVALID: {
        status: 401,
        title: "Kayıt kodu geçersiz, kullanılmış ya da süresi dolmuş",
    },
    AGENT_UNAUTHENTICATED: { status: 401, title: "Ajan kimliği doğrulanamadı" },
    AGENT_CLOCK_SKEW: { status: 401, title: "Ajanın saati sunucudan çok sapıyor" },
    AGENT_TOKEN_REPLAYED: { status: 401, title: "Bu istek daha önce kullanılmış (nonce tekrarı)" },
    AGENT_REVOKED: { status: 401, title: "Bu ajan iptal edilmiş" },
    AGENT_SYNC_GAP: { status: 409, title: "Senkron sırasında boşluk var: beklenen sıradan devam edin" },
    AGENT_COMMAND_NOT_FOUND: { status: 404, title: "Komut bulunamadı" },
    AGENT_COMMAND_STATE_INVALID: { status: 409, title: "Komut bu işlem için uygun durumda değil" },
    AGENT_NOT_ACTIVE: { status: 409, title: "Ajan etkin değil" },
    AGENT_RELEASE_SIGNATURE_INVALID: { status: 422, title: "Yayın manifestinin imzası doğrulanamadı" },
    // Market (Prompt 16)
    STOCK_INSUFFICIENT: {
        status: 409,
        title: "Stok yetersiz: şirket ayarı negatif stoğa izin vermiyor",
    },
    STOCK_COUNT_OUT_OF_SCOPE: { status: 422, title: "Ürün bu sayımın kapsamında değil" },
    GOODS_RECEIPT_LOT_INVALID: {
        status: 422,
        title: "Mal kabulde SKT takipli ürünün son kullanma tarihi eksik ya da geçmiş",
    },
    UNKNOWN_BARCODE: { status: 422, title: "Barkod hiçbir ürüne ait değil" },
    APPROVAL_NOT_ALLOWED: { status: 403, title: "Bu onay talebi hakkında karar veremezsiniz" },
    APPROVAL_ALREADY_DECIDED: { status: 409, title: "Bu onay talebi zaten sonuçlanmış" },
    APPROVAL_PENDING: { status: 409, title: "Bu belge için bekleyen bir onay talebi var" },
    // Filo (Prompt 17, ADR 0017 §14): elle girilen filo fişinde kural ihlali (`meta.action` BLOCK | APPROVAL, `meta.violations`)
    FLEET_RULE_VIOLATION: { status: 422, title: "Filo kuralı ihlal ediliyor" },
    // El yıkama (Prompt 18, ADR 0018 §12–13): randevu kapasitesi / çalışma saatleri ve ödemesiz teslim
    WASH_SLOT_FULL: { status: 409, title: "Bu saat aralığında ünitenin kapasitesi dolu" },
    WASH_OUTSIDE_HOURS: { status: 422, title: "Randevu ünitenin çalışma saatleri dışında" },
    WASH_PAYMENT_REQUIRED: {
        status: 422,
        title: "Teslim için kasa ödemesi ya da ödemesiz teslim gerekçesi gerekiyor",
    },
    // Yıkama makinesi (Prompt 18, ADR 0018 §9): uzaktan başlatma ve müşteri uygulamasından abonelikle başlatma
    WASH_AGENT_UNAVAILABLE: { status: 409, title: "İstasyona şu an ulaşılamıyor; yıkama başlatılamadı" },
    WASH_START_UNSUPPORTED: { status: 422, title: "Bu ünite uzaktan başlatmaya uygun değil" },
    WASH_ENTITLEMENT_DENIED: { status: 422, title: "Abonelik hakkı bu yıkama için kullanılamıyor" },
    // Şarj (Prompt 19, ADR 0019 §5, §12–13): uzaktan başlatma, ortak ağ istasyonu, OCPP kimliği, uygulamadan başlatma hakkı
    EV_CONNECTOR_UNAVAILABLE: {
        status: 409,
        title: "Konnektör şu an kullanılamıyor (meşgul, arızalı ya da ünite çevrimdışı)",
    },
    EV_PARTNER_OPERATED: { status: 422, title: "Bu istasyonun şarjını şarj ağı işletmecisi işletiyor" },
    EV_CHARGER_NOT_FOUND: { status: 404, title: "Şarj ünitesi ya da konnektörü bulunamadı" },
    EV_OCPP_NOT_CONFIGURED: { status: 422, title: "Ünitenin OCPP kimliği tanımlı değil" },
    EV_COMMAND_NOT_ALLOWED: { status: 422, title: "Bu komut bu uçtan gönderilemez" },
    EV_ENTITLEMENT_DENIED: {
        status: 422,
        title: "Şarjı başlatmak için filo hakkı ya da şarj aboneliği gerekiyor",
    },
    // Alarm (Prompt 20, ADR 0020 §3): durum tablosu, yeniden açma çakışması, atanan kişi
    ALARM_INVALID_TRANSITION: { status: 409, title: "Alarm bu işlem için uygun durumda değil" },
    ALARM_DUPLICATE_OPEN: { status: 409, title: "Aynı sorun için zaten açık bir alarm var" },
    ALARM_ASSIGNEE_INVALID: {
        status: 422,
        title: "Alarm bu kullanıcıya atanamaz (etkin üye değil ya da alarmı göremiyor)",
    },
    TOKEN_INVALID: { status: 400, title: "Bağlantı geçersiz ya da süresi dolmuş" },
    WEAK_PASSWORD: { status: 400, title: "Parola yeterince güçlü değil" },
    ACCOUNT_LOCKED: { status: 423, title: "Hesap geçici olarak kilitlendi" },
    PAYLOAD_TOO_LARGE: { status: 413, title: "Gönderilen veri çok büyük" },
    UNSUPPORTED_MEDIA_TYPE: { status: 415, title: "Dosya türü desteklenmiyor" },
    RATE_LIMITED: { status: 429, title: "Çok fazla istek gönderildi" },
    INTERNAL_ERROR: { status: 500, title: "Beklenmeyen bir hata oluştu" },
    SERVICE_UNAVAILABLE: { status: 503, title: "Hizmet geçici olarak kullanılamıyor" },
    // Platform yönetimi (Prompt 24)
    PLATFORM_ACCESS_REQUIRED: { status: 403, title: "Bu işlem platform ekibine özeldir" },
    SUPPORT_ACCESS_READ_ONLY: { status: 403, title: "Destek erişimi salt okunurdur" },
    SUPPORT_ACCESS_ENDED: { status: 403, title: "Destek erişiminin süresi doldu ya da kiracı iptal etti" },
    BILLING_NOT_CONFIGURED: { status: 409, title: "Faturalama kiracısı tanımlı değil" },
};
export const errorCodeSchema = z.enum(Object.keys(ERROR_CODES));
/** Alan bazında doğrulama hatası. `path`: "lines.0.amount" */
export const fieldErrorSchema = z.object({
    path: z.string(),
    code: z.string(),
    message: z.string(),
});
/** RFC 9457 `application/problem+json` gövdesi (AGENTS.md §6). */
export const problemDetailsSchema = z.object({
    type: z.string().describe("Hata türünü tanımlayan URI"),
    title: z.string().describe("Kısa, Türkçe başlık"),
    status: z.number().int(),
    code: errorCodeSchema,
    detail: z.string().optional().describe("Bu olaya özgü Türkçe açıklama"),
    instance: z.string().optional().describe("İsteğin yolu"),
    requestId: z.string().optional().describe("Destek taleplerinde iletilecek istek kimliği"),
    errors: z.array(fieldErrorSchema).optional().describe("VALIDATION_ERROR için alan bazında hatalar"),
    meta: z.record(z.string(), z.unknown()).optional(),
});
export const PROBLEM_TYPE_BASE = "https://docs.istasyon.app/errors/";
export const PROBLEM_CONTENT_TYPE = "application/problem+json";
//# sourceMappingURL=errors.js.map